// // import { useState } from 'react';

// // const  MESFunctionality=()=>{
// //   const [isHovered, setIsHovered] = useState(null);
  
// //   const features = [
// //     { id: 'quality', label: 'Quality', position: 'top' },
// //     { id: 'material', label: 'Material Handling', position: 'right' },
// //     { id: 'maintenance', label: 'Maintenance', position: 'bottom' },
// //     { id: 'energy', label: 'Energy', position: 'left' },
// //   ];

// //   return (
// //     <div className="w-full bg-gradient-to-br from-blue-50 to-gray-100 py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
// //           {/* Left content section */}
// //           <div className="lg:w-1/2 space-y-8">
// //             <h1 className="text-4xl sm:text-5xl font-bold text-blue-900 leading-tight">
// //               MES software functionality
// //             </h1>
            
// //             <p className="text-lg text-gray-700 mt-6">
// //               Support a wide range of processes across discrete, assembly, process/batch manufacturing.
// //             </p>
            
// //             <ul className="space-y-6 mt-8">
// //               <li className="flex items-start">
// //                 <div className="flex-shrink-0 h-6 w-6 mt-1">
// //                   <div className="h-full w-full rounded-full bg-blue-600 flex items-center justify-center">
// //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
// //                       <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
// //                     </svg>
// //                   </div>
// //                 </div>
// //                 <p className="ml-3 text-gray-700">Manage all production, inventory, quality and maintenance operations</p>
// //               </li>
// //               <li className="flex items-start">
// //                 <div className="flex-shrink-0 h-6 w-6 mt-1">
// //                   <div className="h-full w-full rounded-full bg-blue-600 flex items-center justify-center">
// //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
// //                       <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
// //                     </svg>
// //                   </div>
// //                 </div>
// //                 <p className="ml-3 text-gray-700">Enable detailed inventory management and instant bi-directional traceability</p>
// //               </li>
// //               <li className="flex items-start">
// //                 <div className="flex-shrink-0 h-6 w-6 mt-1">
// //                   <div className="h-full w-full rounded-full bg-blue-600 flex items-center justify-center">
// //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
// //                       <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
// //                     </svg>
// //                   </div>
// //                 </div>
// //                 <p className="ml-3 text-gray-700">Low code to easily add connections to machines, lines, add assets and create visual dashboards</p>
// //               </li>
// //             </ul>
            
// //             <div className="pt-6">
// //               <button className="bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105 flex items-center">
// //                 Learn More
// //                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
// //                   <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
// //                 </svg>
// //               </button>
// //             </div>
// //           </div>
          
// //           {/* Right diagram section */}
// //           <div className="lg:w-1/2 flex justify-center">
// //             <div className="relative w-full max-w-md">
// //               {/* Outer circle with gradient */}
// //               <div className="rounded-full bg-gradient-to-br from-blue-100 to-blue-200 aspect-square flex items-center justify-center shadow-lg">
// //                 {/* Feature positions */}
// //                 {features.map((feature) => {
// //                   let positionClasses = "";
                  
// //                   switch(feature.position) {
// //                     case 'top':
// //                       positionClasses = "absolute top-6 left-1/2 transform -translate-x-1/2";
// //                       break;
// //                     case 'right':
// //                       positionClasses = "absolute right-6 top-1/2 transform -translate-y-1/2 text-right";
// //                       break;
// //                     case 'bottom':
// //                       positionClasses = "absolute bottom-6 left-1/2 transform -translate-x-1/2";
// //                       break;
// //                     case 'left':
// //                       positionClasses = "absolute left-6 top-1/2 transform -translate-y-1/2";
// //                       break;
// //                     default:
// //                       break;
// //                   }
                  
// //                   return (
// //                     <div
// //                       key={feature.id}
// //                       className={`${positionClasses} transition-all duration-300`}
// //                       onMouseEnter={() => setIsHovered(feature.id)}
// //                       onMouseLeave={() => setIsHovered(null)}
// //                     >
// //                       <div className={`font-medium text-blue-800 ${isHovered === feature.id ? 'text-blue-600 scale-110' : ''} transition-all duration-300`}>
// //                         {feature.label}
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
                
// //                 {/* Middle circles */}
// //                 <div className="w-3/4 h-3/4 rounded-full bg-blue-300 flex items-center justify-center">
// //                   <div className="w-3/4 h-3/4 rounded-full bg-blue-900 flex items-center justify-center shadow-inner">
// //                     <div className="text-center">
// //                       <p className="text-white font-bold text-lg">Production</p>
// //                       <p className="text-white font-bold text-lg">&amp; Inventory</p>
// //                     </div>
// //                   </div>
// //                 </div>
                
// //                 {/* Connection lines */}
// //                 <div className="absolute inset-0 flex items-center justify-center">
// //                   <svg className="absolute w-full h-full" viewBox="0 0 200 200">
// //                     {/* Top line */}
// //                     <line x1="100" y1="25" x2="100" y2="50" stroke="#3B82F6" strokeWidth="1.5" />
// //                     {/* Right line */}
// //                     <line x1="175" y1="100" x2="150" y2="100" stroke="#3B82F6" strokeWidth="1.5" />
// //                     {/* Bottom line */}
// //                     <line x1="100" y1="175" x2="100" y2="150" stroke="#3B82F6" strokeWidth="1.5" />
// //                     {/* Left line */}
// //                     <line x1="25" y1="100" x2="50" y2="100" stroke="#3B82F6" strokeWidth="1.5" />
// //                   </svg>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
      
// //       {/* Bottom section with stats */}
// //       <div className="max-w-7xl mx-auto mt-16">
// //         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
// //           <div className="bg-white rounded-xl shadow-md p-6 transform transition duration-300 hover:scale-105">
// //             <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
// //               </svg>
// //             </div>
// //             <h3 className="text-lg font-semibold text-blue-900">Increased Productivity</h3>
// //             <p className="text-gray-600 mt-2">Up to 25% increase in overall manufacturing productivity</p>
// //           </div>
          
// //           <div className="bg-white rounded-xl shadow-md p-6 transform transition duration-300 hover:scale-105">
// //             <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
// //               </svg>
// //             </div>
// //             <h3 className="text-lg font-semibold text-blue-900">Real-Time Visibility</h3>
// //             <p className="text-gray-600 mt-2">Monitor production and inventory in real-time across facilities</p>
// //           </div>
          
// //           <div className="bg-white rounded-xl shadow-md p-6 transform transition duration-300 hover:scale-105">
// //             <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
// //               </svg>
// //             </div>
// //             <h3 className="text-lg font-semibold text-blue-900">Quality Assurance</h3>
// //             <p className="text-gray-600 mt-2">Reduce defects by up to 30% with integrated quality controls</p>
// //           </div>
          
// //           <div className="bg-white rounded-xl shadow-md p-6 transform transition duration-300 hover:scale-105">
// //             <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
// //               </svg>
// //             </div>
// //             <h3 className="text-lg font-semibold text-blue-900">Quick Implementation</h3>
// //             <p className="text-gray-600 mt-2">Deploy and see results in 3-4 months with low-code approach</p>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
// import { useState } from 'react';

// const MESFunctionality = () => {
//   const [isHovered, setIsHovered] = useState(null);
  
//   const features = [
//     { id: 'quality', label: 'Quality', position: 'top' },
//     { id: 'material', label: 'Material Handling', position: 'right' },
//     { id: 'maintenance', label: 'Maintenance', position: 'bottom' },
//     { id: 'energy', label: 'Energy', position: 'left' },
//   ];

//   return (
//     <div style={{ width: '100%', padding: '4rem 1rem', overflow: 'hidden', background: 'linear-gradient(to bottom right, #EFF6FF, #F3F4F6)' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
//           {/* Content container */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem', alignItems: 'center' }}>
//             {/* Left content section */}
//             <div style={{ width: '100%', maxWidth: '100%' }}>
//               <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: '700', color: '#1E3A8A', lineHeight: '1.2' }}>
//                 MES software functionality
//               </h1>
              
//               <p style={{ fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: '#374151', marginTop: '1.5rem' }}>
//                 Support a wide range of processes across discrete, assembly, process/batch manufacturing.
//               </p>
              
//               <ul style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                 <li style={{ display: 'flex', alignItems: 'flex-start' }}>
//                   <div style={{ flexShrink: '0', height: '1.5rem', width: '1.5rem', marginTop: '0.25rem' }}>
//                     <div style={{ height: '100%', width: '100%', borderRadius: '50%', backgroundColor: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                       <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1rem', width: '1rem', color: '#FFFFFF' }} viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </div>
//                   </div>
//                   <p style={{ marginLeft: '0.75rem', color: '#374151' }}>Manage all production, inventory, quality and maintenance operations</p>
//                 </li>
//                 <li style={{ display: 'flex', alignItems: 'flex-start' }}>
//                   <div style={{ flexShrink: '0', height: '1.5rem', width: '1.5rem', marginTop: '0.25rem' }}>
//                     <div style={{ height: '100%', width: '100%', borderRadius: '50%', backgroundColor: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                       <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1rem', width: '1rem', color: '#FFFFFF' }} viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </div>
//                   </div>
//                   <p style={{ marginLeft: '0.75rem', color: '#374151' }}>Enable detailed inventory management and instant bi-directional traceability</p>
//                 </li>
//                 <li style={{ display: 'flex', alignItems: 'flex-start' }}>
//                   <div style={{ flexShrink: '0', height: '1.5rem', width: '1.5rem', marginTop: '0.25rem' }}>
//                     <div style={{ height: '100%', width: '100%', borderRadius: '50%', backgroundColor: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                       <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1rem', width: '1rem', color: '#FFFFFF' }} viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </div>
//                   </div>
//                   <p style={{ marginLeft: '0.75rem', color: '#374151' }}>Low code to easily add connections to machines, lines, add assets and create visual dashboards</p>
//                 </li>
//               </ul>
              
             
//             </div>
            
//             {/* Right diagram section */}
//             <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
             
//             <img src="https://ik.imagekit.io/kqumni8l2/MES/MES_functionality_light_565x462.png?updatedAt=1747032770133" alt="Infor Mes" />
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Bottom section with stats */}
//       <div style={{ maxWidth: '1280px', margin: '4rem auto 0' }}>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
//           <div style={{
//             backgroundColor: '#FFFFFF',
//             borderRadius: '0.75rem',
//             boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//             padding: '1.5rem',
//             transition: 'transform 0.3s',
//             transform: 'scale(1)',
//             cursor: 'pointer'
//           }}
//           onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
//           onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
//           >
//             <div style={{ height: '3rem', width: '3rem', backgroundColor: '#DBEAFE', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1.5rem', width: '1.5rem', color: '#2563EB' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//               </svg>
//             </div>
//             <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1E3A8A' }}>Increased Productivity</h3>
//             <p style={{ color: '#4B5563', marginTop: '0.5rem' }}>Up to 25% increase in overall manufacturing productivity</p>
//           </div>
          
//           <div style={{
//             backgroundColor: '#FFFFFF',
//             borderRadius: '0.75rem',
//             boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//             padding: '1.5rem',
//             transition: 'transform 0.3s',
//             transform: 'scale(1)',
//             cursor: 'pointer'
//           }}
//           onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
//           onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
//           >
//             <div style={{ height: '3rem', width: '3rem', backgroundColor: '#DBEAFE', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1.5rem', width: '1.5rem', color: '#2563EB' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1E3A8A' }}>Real-Time Visibility</h3>
//             <p style={{ color: '#4B5563', marginTop: '0.5rem' }}>Monitor production and inventory in real-time across facilities</p>
//           </div>
          
//           <div style={{
//             backgroundColor: '#FFFFFF',
//             borderRadius: '0.75rem',
//             boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//             padding: '1.5rem',
//             transition: 'transform 0.3s',
//             transform: 'scale(1)',
//             cursor: 'pointer'
//           }}
//           onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
//           onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
//           >
//             <div style={{ height: '3rem', width: '3rem', backgroundColor: '#DBEAFE', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1.5rem', width: '1.5rem', color: '#2563EB' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1E3A8A' }}>Quality Assurance</h3>
//             <p style={{ color: '#4B5563', marginTop: '0.5rem' }}>Reduce defects by up to 30% with integrated quality controls</p>
//           </div>
          
//           <div style={{
//             backgroundColor: '#FFFFFF',
//             borderRadius: '0.75rem',
//             boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//             padding: '1.5rem',
//             transition: 'transform 0.3s',
//             transform: 'scale(1)',
//             cursor: 'pointer'
//           }}
//           onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
//           onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
//           >
//             <div style={{ height: '3rem', width: '3rem', backgroundColor: '#DBEAFE', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '1.5rem', width: '1.5rem', color: '#2563EB' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//               </svg>
//             </div>
//             <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1E3A8A' }}>Quick Implementation</h3>
//             <p style={{ color: '#4B5563', marginTop: '0.5rem' }}>Deploy and see results in 3-4 months with low-code approach</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MESFunctionality;



import { useState } from 'react';

const MESFunctionality = () => {
  const features = [
    { id: 'quality', label: 'Quality', position: 'top' },
    { id: 'material', label: 'Material Handling', position: 'right' },
    { id: 'maintenance', label: 'Maintenance', position: 'bottom' },
    { id: 'energy', label: 'Energy', position: 'left' },
  ];

  return (
    <div className="w-full py-16 px-4 overflow-hidden bg-gradient-to-br from-[#EFF6FF] to-[#F3F4F6]">
      <div className="max-w-6xl mx-auto space-y-12">
        {/* Top: Text + Image */}
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Text block */}
          <div className="md:w-1/2 space-y-6">
            <h1
              className="font-extrabold leading-snug"
              style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}
            >
              <span className="text-[#f30000] text-4xl font-bold">Infor MES</span>{' '}
              <span className="text-[#1a1a6f] text-2xl">software functionality</span>
            </h1>
            <p className="text-[#374151] text-base md:text-lg">
              Support a wide range of processes across discrete, assembly,
              process/batch manufacturing.
            </p>

            <ul className="space-y-4">
              {[
                'Manage all production, inventory, quality and maintenance operations',
                'Enable detailed inventory management and instant bi-directional traceability',
                'Low code to easily add connections to machines, lines, add assets and create visual dashboards',
              ].map((text, idx) => (
                <li key={idx} className="flex items-start">
                  <div className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#2563EB] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="ml-3 text-[#374151]">{text}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="md:w-1/2 flex justify-center">
            <img
              src="https://ik.imagekit.io/kqumni8l2/MES/MES_functionality_light.png?updatedAt=1747033304249"
              alt="Infor MES"
              className="h-80 object-contain"
            />
          </div>
        </div>

        {/* Bottom stats */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              iconPath:
                'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
              title: 'Increased Productivity',
              desc: 'Up to 25% increase in overall manufacturing productivity',
            },
            {
              iconPath:
                'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
              title: 'Real-Time Visibility',
              desc: 'Monitor production and inventory in real-time across facilities',
            },
            {
              iconPath:
                'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
              title: 'Quality Assurance',
              desc: 'Reduce defects by up to 30% with integrated quality controls',
            },
            {
              iconPath:
                'M13 10V3L4 14h7v7l9-11h-7z',
              title: 'Quick Implementation',
              desc: 'Deploy and see results in a few months with low-code approach',
            },
          ].map((stat, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl shadow p-6 transform transition-transform hover:scale-105 cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#DBEAFE] rounded-lg flex items-center justify-center mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 text-[#2563EB]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={stat.iconPath}
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-[#1E3A8A]">
                {stat.title}
              </h3>
              <p className="text-[#4B5563] mt-2">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MESFunctionality;
